import {
  addCustomDocumentTitle,
  addDocumentTitle,
  addMetaDescription,
} from '@/helpers'
import { createEffect, type Effect } from 'effector'

/**
 * Used to navigate from old url, for example, /creator/117 to /creator/creator-name-117,
 * will be deleted when users stop using the old url
 */
export const makeSeoFriendlyUrlFx: Effect<string, void> = createEffect(
  (url: string) => window.history.replaceState(window.history.state, '', url)
)

export const setSeoInfoFx = createEffect(
  ({
    title,
    description,
    withPostfix = true,
  }: {
    title: string
    description: string
    withPostfix?: boolean
  }) => {
    addDocumentTitle(title, withPostfix)
    addMetaDescription(description)
  }
)

export const setCustomSeoInfoFx = createEffect(
  ({
    metaTitle,
    metaDescription,
  }: {
    metaTitle: string
    metaDescription: string
  }) => {
    addCustomDocumentTitle(metaTitle)
    addMetaDescription(metaDescription)
  }
)
